var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-eval-delay" },
    [
      _c(
        "yxt-drawer",
        {
          attrs: {
            title: _vm.$t("pc_gwnl_eval_evalDelay" /*测评延期*/),
            "destroy-on-close": true,
            visible: _vm.dialogVisible,
            "before-close": _vm.beforeDrawClose,
            size: "640px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("yxt-blockhead", {
            attrs: {
              title: _vm.$t("pc_eval_baseinfo").d("基本信息"),
              size: "small",
              type: "special",
            },
          }),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "ml16 mt16 mr26",
            },
            [
              _c(
                "yxt-form",
                {
                  ref: "delayForm",
                  attrs: {
                    model: _vm.delayForm,
                    rules: _vm.rules,
                    "label-position": "top",
                    size: "small",
                  },
                },
                [
                  _c(
                    "yxt-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "pc_gwnl_global_lbl_projectName" /* 方案名称 */
                        ),
                        prop: "name",
                      },
                    },
                    [
                      _c("yxt-input", {
                        attrs: {
                          rows: 5,
                          placeholder: _vm
                            .$t("pc_gwnl_global_enterProjectName")
                            .d("请输入方案名称"),
                          maxlength: "50",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.delayForm.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.delayForm, "name", $$v)
                          },
                          expression: "delayForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "yxt-form-item",
                    {
                      attrs: {
                        label: _vm.$t("pc_gwnl_eval_lbl_evalTime"),
                        prop: "evalTime",
                      },
                    },
                    [
                      _c("yxt-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetimerange",
                          size: "small",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss",
                          "default-time": ["00:00:00", "23:59:59"],
                          "picker-options": _vm.pickerOptions,
                          "range-separator": _vm.$t("pc_gwnl_eval_to"),
                          "start-placeholder": _vm.$t("pc_gwnl_eval_startTime"),
                          "end-placeholder": _vm.$t("pc_gwnl_eval_endTime"),
                        },
                        model: {
                          value: _vm.delayForm.evalTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.delayForm, "evalTime", $$v)
                          },
                          expression: "delayForm.evalTime",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "yxt-form-item",
                    {
                      attrs: {
                        label: _vm.$t("pc_gwnl_global_lbl_projectDesc"),
                      },
                    },
                    [
                      _c("yxt-input", {
                        attrs: {
                          type: "textarea",
                          rows: 3,
                          maxlength: "200",
                          placeholder: _vm.$t(
                            "pc_gwnl_global_enterProjectDesc"
                          ),
                          "show-word-limit": "",
                          resize: "none",
                        },
                        model: {
                          value: _vm.delayForm.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.delayForm, "description", $$v)
                          },
                          expression: "delayForm.description",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "yxt-form-item",
                    { attrs: { label: _vm.$t("pc_gwnl_global_remarks") } },
                    [
                      _c("yxt-input", {
                        attrs: {
                          type: "textarea",
                          resize: "none",
                          maxlength: "200",
                          rows: 3,
                          placeholder: _vm.$t("pc_gwnl_eval_enterRemark"),
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.delayForm.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.delayForm, "remark", $$v)
                          },
                          expression: "delayForm.remark",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "yxt-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isBehavior,
                          expression: "!isBehavior",
                        },
                      ],
                      staticClass: "eval-remark1",
                      attrs: { prop: "autoIssueReport" },
                    },
                    [
                      _c(
                        "yxt-checkbox",
                        {
                          attrs: { "true-label": 1, "false-label": 0 },
                          on: { change: _vm.msgTypeChange },
                          model: {
                            value: _vm.delayForm.autoIssueReport,
                            callback: function ($$v) {
                              _vm.$set(_vm.delayForm, "autoIssueReport", $$v)
                            },
                            expression: "delayForm.autoIssueReport",
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("pc_eval_eval_seting_tips")) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("yxt-button", { on: { click: _vm.beforeDrawClose } }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("pc_biz_common_cancel_mini")) +
                    "\n      "
                ),
              ]),
              _c(
                "yxt-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitdelay } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("pc_biz_labelling_confirm")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }